module.exports = __webpack_public_path__ + "img/tow-truck.3d7abebf.svg";